import * as React from "react";
import { RenameDialog } from "@/components/modals/RenameDialog";
import { useReactHookFormAxiosValidation } from "@/hooks/use-react-hook-form-axios-validation";
import { useCreateOrUpdateSnapshotCollectionMutation } from "../../snapshotCollection.api";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";

interface Props {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  snapshotCollection: SnapshotCollection;
}

export const UpdateCollectionModal: React.FC<Props> = ({ isOpen, setIsOpen, snapshotCollection }) => {
  const [createOrUpdateSnapshotCollection] = useCreateOrUpdateSnapshotCollectionMutation();
  const handleReactHookFormAxiosValidation = useReactHookFormAxiosValidation<{ name: string }>();

  return (
    <RenameDialog
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Update SnapShot collection"
      placeholder="Enter collection name"
      initialName={snapshotCollection.name}
      successMessage="SnapShot collection updated"
      onRename={async name => {
        await createOrUpdateSnapshotCollection({ id: snapshotCollection.id, name }).unwrap();
      }}
      onError={handleReactHookFormAxiosValidation}
    />
  );
};
